export default __webpack_public_path__ + "static/media/pro-elevate-red-banner-3.3a41176c.jpg";